import ServiceDetailLayout from '../../components/ServiceDetailLayout';

export default function DigitalMarketingPage() {
  return <ServiceDetailLayout slug="digital-marketing" />;
}
